module.exports = __webpack_public_path__ + "static/img/xeogen-renewal-thumb.2e55c4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/xeogen-renewal-thumb.jpg
// module id = K5W7
// module chunks = 0